<label class="switch">
  <input type="checkbox" [(ngModel)]="enabled" (click)="toggleClicked()">
  <span class="slider round"></span>
</label>
